import React, { useEffect, useState } from "react";
import { Box, Grid, Tab, Tabs, Typography } from "@mui/material";
import DateInput from "../../components/DateInput";
import { getHyphenedDate } from "../../utils/utils";
import { CompanyTitledPage } from "../TitledPage";
import { NormalTable } from "../../components/TableCustomize";
import { salesReportConfirmationColumns } from "./enhance";
import { getSalesReportConfirmation } from "../../http/api/SalesRecordAPI";

export default function SalesReportConfirmation() {
  const [shippingDateInput, setShippingDateInput] = useState(
    getHyphenedDate(new Date())
  );
  const [tableTabPosition, setTableTabPosition] = useState("date");
  const [reportsData, setReportsData] = useState([]);

  const updateShippingDate = (shippingDate) => {
    setShippingDateInput(shippingDate);
  };

  const getSaleReportData = async () => {
    const result = await getSalesReportConfirmation({
      period: tableTabPosition,
      date: shippingDateInput,
    });
    if (result.data) {
      const { reports } = result.data;
      setReportsData(reports.map((report) => {
        report.index = reports.indexOf(report) + 1;
        return report;
      }));
    }
  };

  useEffect(() => {
    getSaleReportData();
  }, [shippingDateInput, tableTabPosition]);

  return (
    <CompanyTitledPage title="売上報告書確認" hideCurrentTime>
      <Grid container spacing={2} alignItems="center">
        <Grid item xs>
          <Tabs
            value={tableTabPosition}
            onChange={(_e, tabPos) => setTableTabPosition(tabPos)}
          >
            <Tab label="当日付" value="date" />
            <Tab label="月間" value="month" />
            <Tab label="年間" value="year" />
          </Tabs>
        </Grid>
        <Grid item xs>
          <Typography sx={{ fontSize: 20, textAlign: "right" }}>
            日付 :
          </Typography>
        </Grid>
        <Grid item xs="auto">
          <DateInput
            value={shippingDateInput}
            onChange={updateShippingDate}
            maxDate={getHyphenedDate(new Date())}
          />
        </Grid>
      </Grid>
      <Box>
        <NormalTable
          columns={salesReportConfirmationColumns}
          data={reportsData || []}
        />
      </Box>
    </CompanyTitledPage>
  );
}
